/**
 * My API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface MachineStatesResponse { 
    states?: Array<string>;
    serial_number?: string;
    fetched_at?: string;
    lookback_days?: number;
}

